export default __webpack_public_path__ + "static/media/acc3.c05f2ace.jpg";